import {
  getContacts
} from '~/api/b2b/general-trade';

export const actions = {
  async getContacts(_) {
    const response = await getContacts();
    if (response.meta.http_status !== 200) throw response;
    return response;
  },
};
